import { RatingTypesServicesMock } from "@/orders/services/ratingTypes/ratingTypes.types";

export const mockRatingTypesService = (): RatingTypesServicesMock => ({
  fetchRatingTypes: jest.fn(),
});
